import React from 'react';

const CategoryDetails = ({ category }) => (
  <>
    {/* <p><strong>Category ID:</strong> {category.id}</p> */}
    <p><strong>Type Name:</strong> {category.type_name}</p>
  </>
);

export default CategoryDetails;
